import { Directive } from '@angular/core';
import { NgxMaskDirective } from 'ngx-mask';

@Directive({
  selector: '[mask]',
})
export class MaskDirective extends NgxMaskDirective {}
